module.exports = __webpack_public_path__ + "img/14.6ea1fae0.svg";